<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<copo-panel-header (backButtonClick)="goBack()"
		[titleHeaderText]="('eorder.orders.request' | translate)+' - '+ ('draftorder.list' | translate)">
	</copo-panel-header>

	<ng-container *ngIf="!isLoading else loading">
		<div class="grid-6 copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
			(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
			<div *ngFor="let order of scroller.list" class="grid-column-one-full card-block">
				<div class="card-order-portal">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="icon_orderrequest" class="header-margin-right"></mat-icon>
							<span class="header-margin-right">{{ getOrderDraftName(order) }}</span>
						</div>
					</div>
					<div class="card-content">
						<div class="card-content-details">
							<div class="card-container-column-drafts">
								<span class="card-content-label-draft draft-title"
									translate>eoffer.product.family</span>
								<ng-container *ngFor="let family of getProductFamilies(order)">
									<span class="draft-family">
										{{ family.subCategoryDescription }}<i *ngIf="family.formDescription"> ({{
											family.formDescription }}) </i>
									</span>
								</ng-container>

							</div>
							<div class="card-container-column-drafts copo-column">
								<span class="card-content-label-draft draft-title "
									translate>number.of.items.label</span>
								<span>{{getNoOfProducts(order) ? getNoOfProducts(order) : UNDERSCORE }}</span>
							</div>

							<div class="card-container-column-drafts copo-column">
								<span class="card-content-label-draft draft-title"
									translate>eorder.wizard.summary.total.quantity</span>
								<span class="tag-tonnage">
									{{getTotalQuantity(order) ? getTotalQuantity(order) + ' t' : UNDERSCORE}}
								</span>
							</div>
							<div class="card-container-column-drafts">
								<span class="card-content-label-draft draft-title" translate>draft.creationdate</span>
								<span>{{ order.creationDate | copoDate:'date' }}</span>
							</div>
							<div class="card-container-column-drafts">
								<span class="card-content-label-draft draft-title"
									translate>datacenter-filter.order-creator</span>
								<span>{{ getCreatorName(order) }}</span>
							</div>
						</div>
						<div class="card-container-column-drafts copo-title card-column-end">
							<div class="card-container-link">
								<button type="button" mat-icon-button
									class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtEditEordrDraft(order)" [matTooltip]="'continue.draft' | translate">
									<mat-icon color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
									</mat-icon>
								</button>
								<button type="button" mat-icon-button
									class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtDeleteDraftOrder(order)" [matTooltip]="'delete.draft' | translate">
									<mat-icon color="accent" svgIcon="garbage" class="image-draft-list-icon"></mat-icon>
								</button>
							</div>
							<div class="card-container-link draft-list-viewdetails">
								<a mat-button color="primary" (click)="$event.preventDefault();evtGoToOrderCard(order)"
									href="#">
									<span translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full"
				*ngIf="!scroller.loading && scroller.list.length === 0">eorder.draft.norequest</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>

</div>